import { BaseNode } from "./Node/BaseNode";
import { TreeNodeMeddraLevel } from "./Node/MeddraNode/ListEntity/TreeNodeMeddraLevel";
import { QueryConditionsNode } from "./Node/QueryConditionsNode";
import { QueryFieldsNode } from "./Node/QueryFieldsNode";
import { QueryResultNode } from "./Node/QueryResultNode";
import { SimpleSearchListNode } from "./Node/SimpleSearchListNode";

export class CheckedManagement {
 static manageFieldsNodeItemChecked(node: BaseNode, checkedStatus: boolean) {
    const arrayModel = Object.entries(node.data.model).map(([key, value]) => {
      return { key, value };
    });

    arrayModel.forEach((item: any, index: number) => {
      if ((item.key !== 'num') && ((node.data.fields[index].props['readonly'] === undefined) || 
                                   (node.data.fields[index].props['readonly'] === false)
                                  )) {
        item.value = checkedStatus;
      }
    });

    let newModel = arrayModel.reduce((acc: any, item) => {
      acc[item.key] = item.value;
      return acc;
    }, {});

    node.data.model = newModel;
  }

  static manageQueryResultNodeItemChecked(node: BaseNode, checkedStatus: boolean) {
    const arrayModel = Object.assign(node.data.model);

    arrayModel.forEach((item: any) => item.checked = checkedStatus);
  }

  static manageSimpleSearchListNode(node: SimpleSearchListNode | TreeNodeMeddraLevel, checkedStatus: boolean) {

    if (node.showResults){   
      const arrayModel = Object.assign(node.data.model);
      arrayModel.forEach((item: any) => item.checked = checkedStatus);
    }else{
      const treeModel = Object.assign(node.children!);
      treeModel.forEach((item: any) => item.checked = checkedStatus);
    }

  }

  static uncheckConditionsNode(node: BaseNode) {
    let keys = Object.keys(node.data.model);
    let permanentItem = node.data.fields.filter((c: any) => c.props['permanentCheck']).map((c: any) => c.key)
    keys.forEach(key => { 
      if (!permanentItem.includes(key)) {
        node.data.model[key] = ""
      }
    });
    node.data.fields = [...node.data.fields];
  }

  static manageItemChecked(node: BaseNode, checkedStatus: boolean) {
    if (node instanceof QueryFieldsNode) {
      this.manageFieldsNodeItemChecked(node, checkedStatus);
    } else if (node instanceof QueryResultNode) {
      this.manageQueryResultNodeItemChecked(node, checkedStatus);
    } else if (node instanceof SimpleSearchListNode || node instanceof TreeNodeMeddraLevel) {
      this.manageSimpleSearchListNode(node, checkedStatus);
    } else if (node instanceof QueryConditionsNode) {
      this.uncheckConditionsNode(node);
    }
  }

}